import React from 'react'
import { IconProps } from '../../types/types'

const IconMoon:React.FC<IconProps> = ({ size = '15', color = '#1E1E1E' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.18542 7.2524C1.39563 10.2596 3.9474 12.7063 7.00134 12.8406C9.15604 12.934 11.083 11.9297 12.2392 10.3472C12.718 9.69906 12.4611 9.26696 11.6611 9.41294C11.2699 9.48301 10.8669 9.51221 10.4465 9.49469C7.59111 9.3779 5.2554 6.98963 5.24372 4.16926C5.23788 3.41015 5.39554 2.69192 5.68166 2.03792C5.99699 1.31385 5.61743 0.969332 4.88752 1.27881C2.57516 2.25397 0.992719 4.58385 1.18542 7.2524Z" stroke={color} strokeWidth="1.16786" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default IconMoon